import { parseCookies } from '@cian/utils';
import { getConfig } from '@cian/config/browser';
import { getLogger } from '@cian/logger/browser';
export function sendTeaserEvent(payload, action) {
  var _banner$id;
  var cid = parseCookies(document.cookie)['_CIAN_GK'];
  var teaserApiUrl = getTeaserApiUrl();
  if (!teaserApiUrl) {
    return;
  }
  var banner = payload.banner,
    pageType = payload.pageType;
  fetch(teaserApiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      device_type: 'desktop',
      cid: cid,
      pageType: pageType,
      items: [{
        action: action,
        bannerId: (_banner$id = banner.id) === null || _banner$id === void 0 ? void 0 : _banner$id.toString(),
        bannerPlace: banner.place,
        timestamp: Date.now(),
        dl: window.location.href
      }]
    })
  });
}
function getTeaserApiUrl() {
  var config = getConfig();
  var logger = getLogger();
  var soprExperimentsForTeaserUrl = config.get('soprExperimentsForTeaserUrl');
  if (!soprExperimentsForTeaserUrl) {
    logger.error('soprExperimentsForTeaserUrl is not defined', {
      domain: 'getTeaserApiUrl'
    });
    return null;
  }
  return "".concat(soprExperimentsForTeaserUrl, "teaser/");
}